export default __webpack_public_path__ + "8e7221d9af7bae2862783e4a6fd23845.png";